import { Check, Plus, AlertTriangle, AlertCircle, XCircle } from "lucide-react";

export function JourneyStatusBadge({ status }: { status: string }) {
  switch (status) {
    case "resolved":
      return (
        <span className="inline-flex items-center gap-1 rounded bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border border-emerald-500/30 px-2 py-0.5 text-xs font-medium">
          <Check className="size-3" />
          <span>Resolved</span>
        </span>
      );
    case "new_path":
      return (
        <span className="inline-flex items-center gap-1 rounded bg-sky-500/10 text-sky-700 dark:text-sky-400 border border-sky-500/30 px-2 py-0.5 text-xs font-medium">
          <Plus className="size-3" />
          <span>New path</span>
        </span>
      );
    case "regression":
      return (
        <span className="inline-flex items-center gap-1 rounded bg-destructive/10 text-destructive border border-destructive/30 px-2 py-0.5 text-xs font-medium">
          <AlertTriangle className="size-3" />
          <span>Regression</span>
        </span>
      );
    case "persists":
      return (
        <span className="inline-flex items-center gap-1 rounded bg-amber-500/10 text-amber-700 dark:text-amber-400 border border-amber-500/30 px-2 py-0.5 text-xs font-medium">
          <AlertCircle className="size-3" />
          <span>Persists</span>
        </span>
      );
    case "stalled":
      return (
        <span className="inline-flex items-center gap-1 rounded bg-destructive/10 text-destructive border border-destructive/30 px-2 py-0.5 text-xs font-medium">
          <XCircle className="size-3" />
          <span>Stalled in baseline</span>
        </span>
      );
    case "bypassed":
      return (
        <span className="inline-flex items-center gap-1 rounded bg-muted text-muted-foreground border border-border px-2 py-0.5 text-xs font-medium">
          <span>Bypassed</span>
        </span>
      );
    default:
      return (
        <span className="inline-flex items-center gap-1 rounded bg-muted/60 text-muted-foreground border border-border/60 px-2 py-0.5 text-xs font-medium">
          <span>Same</span>
        </span>
      );
  }
}
